// This is the list of pages that are tracked by analytics.
// Without this regex matching, page views will not be tracked correctly by amplitude.
export const pageKeyRegex = {
  root: /^\/{1}$/, // matches '/'
  seedPhraseEntry: /^\/seed-phrase/, // matches '/seed-phrase'
  securityFrame: /^\/security-frame/, // matches '/security-frame'
  securityFrameThinking: /^\/security-frame\/thinking/, // matches '/security-frame/thinking'
  scanning: /^\/[0-9a-f]+\/scanning/, // '/:fingerprint/scanning
  enterWalletAddresses: /^\/[0-9a-f]+\/enter-wallet-addresses/, // '/:fingerprint/enter-wallet-addresses
  review: /^\/[0-9a-f]+\/review/, // '/:fingerprint/review
  broadcasting: /^\/[0-9a-f]+\/broadcasting/, // '/:fingerprint/broadcasting
  status: /^\/[0-9a-f]+\/status/, // '/:fingerprint/status
};

const pageKeyRegexes = Object.entries(pageKeyRegex).map(([pageKey, regex]) => ({ pageKey, regex }));

function getPageKeyFromPathname(pathname: string) {
  return pageKeyRegexes.find(({ regex }) => pathname.match(regex))?.pageKey ?? undefined;
}

/**
 * Use this to get the pageKey based on the curreny path
 * e.g. `getRouteKeyFromPath(window.location.href)`
 * @param pathStr the current path
 * @returns a pageKey or undefined
 */
export function getPageKeyFromPath(pathStr: string) {
  try {
    const { pathname } = new URL(pathStr, window.location.origin);
    return getPageKeyFromPathname(pathname);
  } catch {
    return undefined;
  }
}
